import MainTitle from "@/components/mainTitle/MainTitle";
import {
  StyledContainer,
  StyledContentContainer,
  StyledDesktopRobot,
  StyledRobotContainer,
  StyledTabletRobot,
  StyledTag,
  StyledTagsContainer,
  StyledDescription,
} from "./Banner.styles";

const Banner = () => {
  const tags = ["情境化命題", "跨領域整合", "真實問題解決"];

  return (
    <StyledContainer>
      <StyledRobotContainer>
        <StyledDesktopRobot
          src="/generationPage/half_robot.svg"
          alt="robot"
          width="100%"
          height="auto"
        />
        <StyledTabletRobot
          src="/generationPage/robot.svg"
          alt="robot"
          width="100%"
          height="auto"
        />
      </StyledRobotContainer>
      <StyledContentContainer>
        <MainTitle suffix="素養題" size="medium" />
        <StyledTagsContainer>
          {tags.map((tag) => (
            <StyledTag key={tag}>{tag}</StyledTag>
          ))}
        </StyledTagsContainer>
        <StyledDescription variant="body1">
          南一 AI 智慧夥伴的 AI
          素養出題，從真實情境出發，評量學生的知識應用、問題解決與統整能力，讓素養評量更貼近教學核心！
        </StyledDescription>
      </StyledContentContainer>
    </StyledContainer>
  );
};

export default Banner;
